<template>
  <div>
    <h1>Lista de Perfis</h1>
    <div v-if="cliente.id">
      <b-card>
        <b-table
          striped
          hover
          :items="cliente?.perfis"
          :fields="fields"
          show-empty
        >
          <template #cell(nome)="{ item }">
            {{ item.nome ?? item.razao_social }}
          </template>
          <template #cell(categoria_instituicao_id)="{ item }">
            {{ getCategoriaInstituicaoById(item?.categoria_instituicao_id) }}
          </template>
          <template #cell(tipo_instituicao_id)="{ item }">
            {{ getTipoInstituicaoById(item?.tipo_instituicao_id) }}
          </template>
          <template #cell(cidade_id)="{ item }">
            {{ getCidadeEUF(item?.cidade) }}
          </template>
          <template #cell(status)="{ item }">
            <font-awesome-icon
              :icon="getIconUser(item)"
              :class="getClassUser(item)"
            />
          </template>
          <template #cell(actions)="row">
            <div
              class="table-actions d-flex justify-content-end cursor-pointer mr-2"
            >
              <b-button
                variant="outline-exitos"
                @click="
                  $router.push({
                    name: 'perfis_edit',
                    params: { id: row.item.id },
                  })
                "
              >
                <font-awesome-icon icon="far fa-edit" />
              </b-button>
            </div>
            <!-- Comentado pois função será implementada posteriormente -->
            <!-- <Actions :item="row.item" :view_show="false" :view_edit="$can('user:edit')"
              :view_delete="$can('user:delete')" edit_to="users_edit" @delete="delete_user" /> -->
          </template>

          <template #empty="{}">
            <h5 class="text-center">Nenhum item encontado</h5>
          </template>
        </b-table>
      </b-card>

      <div class="mt-4">
        <pagination-nav
          v-model="pagination.current_page"
          :pagination="pagination"
          @input="loadData()"
        />
      </div>
    </div>
    <div v-else>
      <base-alert type="info" class="m-4 p-4 text-center">
        <span class="alert-inner--icon mr-2">
          <font-awesome-icon icon="fas fa-exclamation-triangle" />
        </span>
        <span class="alert-inner--text">
          <strong>Atenção!</strong><br />
          Para visualizar os Perfis do Cliente é necessário, primeiro, salvar
          as informações!
        </span>
      </base-alert>
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Actions },
  data: () => ({
    termo_pesquisa: "",
    per_page: 15,
    sortBy: "ativo",
    sortDesc: true,
    instituicoes: [],
    categorias: [],
  }),
  computed: {
    ...mapState("clientes", ["cliente"]),
    ...mapState("perfis", ["perfis_list", "pagination"]),
    fields() {
      return [
        { key: "id", label: "COD", class: "col-1" },
        { key: "nome", label: "Nome" },
        { key: "categoria_instituicao_id", label: "Categoria da instituição", class: "text-center" },
        { key: "tipo_instituicao_id", label: "Tipo de instituição", class: "text-center" },
        { key: "cidade_id", label: "Cidade/UF", class: "text-center" },
        { key: "status", label: "Status" },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    ...mapActions("perfis", ["ActionGetAllCategories"]),
    ...mapActions("tipos_instituicoes", ["ActionFind"]),
    ...mapActions("municipios", ["ActionFindById"]),
    getIconUser(item) {
      return item.status ? "check-circle" : "times-circle";
    },
    getClassUser(item) {
      return !!item.status ? "text-success" : "text-danger";
    },
    getCategoriaInstituicaoById(id) {
      if (!id) return '-';
      const response = this.categorias.find(item => item.id === id).nome;
      return response;
    },
    getTipoInstituicaoById(id) {
      if (!id) return '-';
      const response = this.instituicoes.find(item => item.id === id).nome;
      return response;
    },
    getCidadeEUF(cidade) {
      return `${cidade?.nome} - ${cidade?.estado_sigla}`;
    }
  },
  async created() {
    const response_instituicoes = await this.ActionFind({ per_page: 100 });
    const response_categorias = await this.ActionGetAllCategories();
    this.instituicoes = response_instituicoes.data;
    this.categorias = response_categorias.data;
  },
};
</script>
